<!-- =========================================================================================
    File Name: ChatLog.vue
    Description: Chat Application - Log of chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<!-- hasSentPreviousMsg -->
<template>
  <div id="visualizer">
    <!-- <pre>{{artefact}}</pre> -->
    <vx-card v-if="false && artefact && artefact.res && !(artefact.res.index || artefact.res.trend || artefact.res.order) && artefact.res.error">
      <h2>Note</h2>

      <vs-alert color="danger" icon="new_releases" active="true" class="mt-5">
        <p>{{artefact.res.error}}</p>
      </vs-alert>
    </vx-card>
    <vx-card
      v-if="artefact && artefact.res && (artefact.res.index || artefact.res.trend || artefact.res.order) && !artefact.res.error"
      :title="artefact.query"
      :subtitle="artefact.guide.subtitle"
    >
      <div class="flex justify-between items-end flex-grow">
        <div class="flex flex-wrap items-center md:justify-between">
          <div class="flex flex-wrap">
            <vs-chip :color="index === 0 ? 'primary' : ''" v-for="(tag, index) in artefact.tags" :key="index">
              <vs-avatar :text="tag.type" />
              {{ tag.tag }}
            </vs-chip>
          </div>
        </div>
        <!-- <div class="flex flex-wrap"> -->
          <!-- Filter -->
          <!-- <vs-select
            :value="currentFilter"
            class="mr-4 vs-input-shadow-drop vs-select-no-border d-theme-input-dark-bg w-48"
          >
            <vs-select-item value="all" text="All SKUs"/>
            <vs-select-item value="competitive" text="Competitive SKUs" />
            <vs-select-item value="need_action" text="SKUs Need Action" />
            <vs-select-item value="exceptions" text="SKUs With Issues" />
          </vs-select>-->

          <!-- ITEM VIEW - GRID/LIST -->
          <!-- <div>
            <feather-icon
              icon="GridIcon"
              @click="changeView('item-grid-view')"
              class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
              :svgClasses="{'text-primary stroke-current': currentItemView == 'item-grid-view'}"
            />
            <feather-icon
              icon="FilterIcon"
              @click="changeView('item-list-view')"
              class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer hidden sm:inline-flex"
              :svgClasses="{'text-primary stroke-current': currentItemView == 'item-list-view'}"
            />
            <feather-icon
              icon="UploadIcon"
              @click="addNewData"
              class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer hidden sm:inline-flex"
              :svgClasses="{'text-primary stroke-current': currentItemView == 'item-manage-view'}"
            />
          </div> -->
        <!-- </div> -->
      </div>
      <vs-alert color="primary" icon="new_releases" active="true" class="mt-5" v-if="artefact.note">
        <p>{{artefact.note}}</p>
      </vs-alert>
    </vx-card>
    <div
      class="mt-base"
      v-if="artefact && artefact.res && (artefact.res.trend || artefact.res.order) && !artefact.res.error"
    >
      <div v-if="['SFM', 'SSM'].includes(artefact.type)">
        <!-- <vs-tabs>
          <vs-tab label="Categories" icon-pack="feather" icon="icon-home">
            <trend :artefact="artefact" :key="artefact.type+'-1'" type="category"></trend>
            <item-list :artefact="artefact" :key="artefact.type+'-2'" type="category"></item-list>
          </vs-tab>
          <vs-tab label="SKUs" icon-pack="feather" icon="icon-box"> -->
            <trend :artefact="artefact" :key="artefact.type+'-1'" type="sku"></trend>
            <item-list :artefact="artefact" :key="artefact.type+'-2'" type="sku"></item-list>
          <!-- </vs-tab>
        </vs-tabs> -->
      </div>
      <div v-if="['FSM'].includes(artefact.type)">
        <trend :artefact="artefact" :key="artefact.type+'-1'" type="category"></trend>
        <item-list :artefact="artefact" :key="artefact.type+'-2'" type="category"></item-list>
      </div>
      <div v-if="['SST', 'CST', 'BST', 'CSST', 'BSST'].includes(artefact.type)">
        <trend :artefact="artefact" :key="artefact.type+'-1'" type="trend"></trend>  
      </div>
    </div>
    
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Trend from "./Trend.vue";
import ItemList from "./ItemList.vue";

export default {
  props: {
    artefact: { type: Object, required: true }
  },
  data() {
    return {
    };
  },
  watch: {},
  computed: {},
  methods: {
  },
  mounted() {
  },
  components: {
    Trend,
    ItemList
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/pages/profile.scss";
#visualizer {
  .tagger {
    padding: 0.5rem 1rem;
    border-radius: 25px;
    margin-right: 1rem;
    margin-bottom: 1.5rem;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
      0 5px 15px 0 rgba(0, 0, 0, 0.08);
  }
  .tasks-today-container {
    .tasks-today__task {
      transition: background 0.15s ease-out;
      .tasks-today__actions {
        display: none;
      }

      &:hover {
        background: rgba(var(--vs-primary), 0.04);
        .tasks-today__actions {
          display: flex;
        }
      }
    }
  }

  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
